/*
 * @Author: Dong
 * @Date: 2023-02-12 11:14:22
 * @LastEditors: zhang lin
 * @LastEditTime: 2023-02-13 15:56:17
 */
import { SET_IS_MULTI_TENANT, SET_DOMAIN } from '../constant';

export interface tenantStates {
  isMultiTenant: boolean;
  domain: string;
}

const defaultStates: tenantStates = {
  isMultiTenant: false, // 是否为多租户
  domain: '', // 泛域名
};

const tenant = (state = { ...defaultStates }, action: any) => {
  const { type, payload } = action;

  switch (type) {
    case SET_IS_MULTI_TENANT: {
      return {
        ...state,
        isMultiTenant: payload,
      };
    }
    case SET_DOMAIN: {
      return {
        ...state,
        domain: payload,
      };
    }

    default:
      return state;
  }
};

export default tenant;
